export const LONG_DATE = 'MMMM d, yyyy';
export const SHORT_DATE = 'MM/dd/yyyy';
